import { useState, useEffect, useRef } from "react";

export enum AppLoadingState {
    NONE = "NONE",
    START_LOADING = "START_LOADING",
    STILL_LOADING = "STILL_LOADING",
    LOADED = "LOADED"
}

export default (settings?: any) => {
    const [viewState, setViewState] = useState<string>("NONE");
    const appLoadTimer = useRef<any>(null);

    useEffect(() => {
        if (typeof (settings) === "undefined") {
            appLoadTimer.current = setTimeout(() => {
                setViewState("START_LOADING");

                appLoadTimer.current = setTimeout(() => {
                    setViewState("STILL_LOADING");
                }, 2000);
            }, 250);
        }

        if (typeof (settings) !== "undefined") {
            const waitTime = viewState === "START_LOADING" ? 2000 : 0;

            clearTimeout(appLoadTimer.current);

            appLoadTimer.current = setTimeout(() => {
                setViewState("LOADED");
            }, waitTime);
        }
    }, [settings]);

    return viewState;
}